import { render, staticRenderFns } from "./CanteenPast.vue?vue&type=template&id=726d587e"
import script from "./CanteenPast.vue?vue&type=script&lang=js"
export * from "./CanteenPast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports